import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useUpdatePaymentStatus = () => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ paymentId, status }) => {
      if (!tenantVal) throw new Error("Tenant not found");
      
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/consultationpaymentdue/id/${paymentId}/status/${status}`
      );
      return response.data;
    },
    onError: (error) => {
      toast.error(`Failed to update payment status: ${error.message}`);
    }
  });
};